"use client";

import { Header } from "@/components/layout/Header";
import { Sidebar } from "@/components/layout/sidebar/Sidebar";
import { PageNameProvider } from "@/contexts/PageNameContext";
import { useEffect } from "react";

export default function AuthenticatedLayoutInternal({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    const spinnerContainer = document.getElementById(
      "loading-spinner-container",
    );
    if (spinnerContainer) {
      spinnerContainer.style.opacity = "0";
      spinnerContainer.style.pointerEvents = "none";
      spinnerContainer.style.transition = "opacity 300ms ease";

      setTimeout(() => {
        spinnerContainer.style.display = "none";
      }, 300);
    }
  }, []);

  return (
    <PageNameProvider>
      <div className="relative flex h-full overflow-hidden bg-palette-surface-main p-spacing-2">
        <div className="flex gap-spacing-2 w-full h-full z-10">
          <Sidebar />
          <div className="h-full flex flex-col flex-1 overflow-hidden gap-spacing-2">
            <Header />
            <main className="h-full w-full py-spacing-9 px-spacing-11 pb-24 overflow-auto bg-palette-surface-default70 rounded-md border-[0.56px] border-palette-grey-0">
              {children}
            </main>
          </div>
        </div>
        <div className="absolute h-[445px] w-[445px] top-[11px] left-[1040px] bg-palette-orange-40020 rounded-full blur-[206.39px] z-0" />
        <div className="absolute h-[445px] w-[445px] top-[331px] left-[128px] bg-palette-yellow-40030 rounded-full blur-[206.39px] z-0" />
        <div className="absolute h-[445px] w-[445px] top-[803px] -left-[205px] bg-palette-orange-40020 rounded-full blur-[206.39px] z-0" />
        <div className="absolute h-[609px] w-[609px] top-[624px] left-[1338px] bg-[#C9C9DA] rounded-full blur-[206.39px] z-0" />
        <div className="absolute h-[609px] w-[609px] -top-[365px] left-[670px] bg-[#C9C9DA] rounded-full blur-[206.39px] z-0" />
        <div className="absolute h-[609px] w-[609px] top-[702px] left-[507px] bg-[#F3F3FC] rounded-full blur-[206.39px] z-0" />
      </div>
    </PageNameProvider>
  );
}
